import React, { useMemo } from 'react';
import styled from 'astroturf/react';
import { currentUser } from 'js/utils/user';
import { Body } from 'js/design_system/Body';
import {
  PostReasonData,
  PaperUpdateReasonData,
  FollowableUser,
} from 'js/social/shared/types';
import pluralize from 'pluralize';
import { OverlappingAvatars } from 'js/social/shared/OverlappingAvatars';
import _Container from "Reason-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Reason.tsx?styleId=Container";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

type Props = {
  type: keyof PostReasonData | keyof PaperUpdateReasonData;
  users: FollowableUser[];
  totalUsers: number;
  className?: string;
};

export const Reason: React.FunctionComponent<Props> = ({
  type,
  users,
  totalUsers,
  className,
}) => {
  const userText = useMemo(() => {
    const names = users.map((user) => {
      return currentUser?.id === user.id ? 'You' : user.displayName;
    });

    if (totalUsers === 0) {
      return '';
    } else if (totalUsers === 1) {
      return names[0];
    } else if (totalUsers === 2) {
      return `${names[0]} and ${names[1]}`;
    } else {
      return pluralize(
        `${names[0]}, ${names[1]}, and ${totalUsers - 2} other`,
        totalUsers - 2,
      );
    }
  }, [users, totalUsers]);

  const text = useMemo(() => {
    const reasonText: { [reason: string]: string } = {
      source_user_comment: `${userText} commented`,
      source_user_reply: `${userText} replied`,
      source_user_like: `${userText} liked`,
      source_user_repost: `${userText} reposted`,
      tagged_in_post: 'You were tagged',
      tagged_in_comment: 'You were tagged in a comment',
      recommended: 'Recommended for you',
      boosted: 'Recommended for you',
      fallback_content: 'Posted recently',
      hoisted: 'Recommended for you',
    };

    return reasonText[type] ?? null;
  }, [type, userText]);

  if (!text) return null;

  return (
    <Container className={className}>
      <OverlappingAvatars users={users} />

      <Body size="sm">{text}</Body>
    </Container>
  );
};
